var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":e => _vm.$emit('click', e)}},[(_vm.showText)?[_c('a-icon',{staticClass:"icon",attrs:{"type":"upload"}}),_c('span',{staticClass:"text"},[_vm._v("上传")])]:_c('a-tooltip',{attrs:{"title":"上传"}},[_c('a-icon',{staticClass:"icon",attrs:{"type":"upload"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }